import { combineReducers } from 'redux'; 
import CustomerReducer from './customer'


const rootReducer = combineReducers({
    CustomerReducer
  });
  
  export default rootReducer;